import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=7a124828&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a124828')) {
      api.createRecord('7a124828', component.options)
    } else {
      api.reload('7a124828', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=7a124828&", function () {
      api.rerender('7a124828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Text.vue"
export default component.exports